export default __webpack_public_path__ + "static/media/0_Still.a16f66ef.jpg";